import { computed, ComputedRef } from 'vue'
import { DateTime } from 'luxon'
import { getChristmasEve } from '@/composables/themes/holidayHelper'

export type UseChristmas = {
  /** Christmas for the current year */
  christmasEve: DateTime
  /** True if today is Christmas */
  isChristmasEve: ComputedRef<boolean>
  /**
   * True if today is between 4 weeks before Christmas-Eve
   * and 2 week after Christmas-Eve
   */
  isWithinChristmasRange: ComputedRef<boolean>
}

function useChristmas(): UseChristmas {
  const now = DateTime.local().startOf('day')
  const christmasEve = getChristmasEve(now.year)

  const isChristmasEve = computed(() => now.hasSame(christmasEve, 'day'))

  const christmasRangeStart = christmasEve.minus({ weeks: 4 })
  const christmasRangeEnd = christmasEve.plus({ weeks: 2 })
  const isWithinChristmasRange = computed(() => now >= christmasRangeStart && now <= christmasRangeEnd)

  return {
    christmasEve,
    isChristmasEve,
    isWithinChristmasRange,
  }
}

export default useChristmas
